import cn from 'classnames'
import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { Nullable } from 'legacy/lut/classes/models/utils'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { BusinessUnit } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/businessUnit/BusinessUnit'
import { DescriptionQuality } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/descriptionQuality/DescriptionQuality'
import { isDescriptionQualityBlocking } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/descriptionQuality/helpers'
import { FocusArea } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/focusArea/FocusArea'
import { FormFieldValidationLabel } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/formFieldValidationLabel/FormFieldValidationLabel'
import { Goal } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/goal/Goal'
import { Incremental } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/incremental/Incremental'
import { InvestmentSource } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/investmentSource/InvestmentSource'
import { InvestmentSum } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/investmentSum/InvestmentSum'
import { KeyObjectives } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/keyObjectives/KeyObjectives'
import { KeyObjectivesTree } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/keyObjectivesTree/KeyObjectivesTree'
import { Name } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/name/Name'
import { Status } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/status/Status'
import { ValueTypeAndCurrency } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/valueTypeAndCurrency/ValueTypeAndCurrency'
import { isKeyObjectiveRelated } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/helpers/isKeyObjectiveRelated'
import { useDescriptionQuality } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/hooks/useDescriptionQuality'
import { useFocusAreaValues } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/hooks/useFocusAreaValues'
import { useIncremental } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/hooks/useIncremental'
import { useResetProgressOnPracticeDevelopmentExit } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/hooks/useResetProgressOnPracticeDevelopmentExit'
import { KeyInitiativeInitTypes } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/models/keyInitiativeInitTypes'
import { ApplyButton } from 'legacy/lut/components/widgets/public/partner360/editors/ApplyButton'
import { CancelButton } from 'legacy/lut/components/widgets/public/partner360/editors/CancelButton'
import { formatMoneyInteger } from 'legacy/lut/components/widgets/public/partner360/helpers/formatMoneyInteger'
import { reviewKeyInitiative, selectRtm } from 'legacy/lut/features/partner360/configuration'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { TReplaceOptions } from 'legacy/lut/library/translation/models/replaceOptions'
import { IJBPActualsAndTargetsCategory } from 'legacy/lut/services/partner360/common/models/jbpActualsAndTargetsCategories'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import {
  FormCheckBox,
  FormInput,
  FormSwitch,
  FormTextarea,
  resetAllModifiedDataByKey,
  updateFormDataField,
  useGetFormData,
} from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { TFormValidationResult } from 'cng-common/features/form/models'
import { FormValidationBuilder } from 'cng-common/features/form/utils/validation'
import { Translation } from 'cng-common/features/translations/components/translation'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { Checkbox } from 'core-components/library/checkbox'
import { Grid, Item } from 'core-components/library/grid'
import { LoaderOverlay } from 'core-components/library/loader'
import { InitiativeStatus } from 'partner360/entities/keyInitiatives/model/status'
import { INITIATIVES_EDITOR_TYPE_LEGACY } from 'partner360/features/keyInitiativeEditor/model/editorConfig'

import { ActivityType } from '../../../../../commonComponents/editorComponents/components/activityType/ActivityType'
import { PeriodSelector } from '../../../../../commonComponents/editorComponents/components/periodSelector/PeriodSelector'
import { ProgressDropdown } from '../../../../../commonComponents/editorComponents/components/progressDropdown/ProgressDropdown'
import { useBusinessUnits } from '../../../../../hooks/useBusinessUnits'
import { TRANSLATION_KEYS as tr } from '../../../../../translations'
import {
  EXTENDED_BUSINESS_UNITS_BLANK,
  EXTENDED_BUSINESS_UNITS_PRINT,
  EXTENDED_BUSINESS_UNITS_PS,
  EXTENDED_FOCUS_AREA,
  IS_VALIDATE_ON_OPENING,
  PRACTICE_DEVELOPMENT,
  PROGRESS_VIEW_ITEMS,
  PROGRESS_VIEW_LABEL_SUFFIX,
} from '../../configs'
import { finSobValidation } from '../../helpers/finSobValidation'
import { getDescriptionRows } from '../../helpers/getDescriptionRows'
import {
  getIsPracticeDevelopment,
  getPracticeDevelopmentProgressValues,
} from '../../helpers/getPracticeDevelopmentProgressValues'
import { IKeyInitiativeEditorContentProps } from '../../models/IKeyInitiativeEditorContentProps'
import { IKeyInitiativeForm } from '../../models/keyInitiativeForm'
import { WidgetView } from '../content/widgetView/WidgetView'

import styles from './KeyInitiativeEditorContent.module.scss'

export const KeyInitiativeEditorContent = ({
  initialData,
  programType,
  onApply,
  onCancel,
  saveAsNew,
  isCommercial,
  isDataInsightPresent,
  isDataInsightTab = false,
  isAmplifyImpactInfoSection = false,
  keyObjectivesFilter,
  pendingKeyInitiative,
  finSobData,
  keyInitiativesFormat = INITIATIVES_EDITOR_TYPE_LEGACY,
  setKeyInitiativesFormat,
  fYear,
  keyObjectives,
  initiativeFormKey,
}: IKeyInitiativeEditorContentProps) => {
  /** -------------------- State ----------------------- */

  const [isLoading, setIsLoading] = useState(false)
  const [isInvestmentNeeds, setInvestmentNeeds] = useState(
    [initialData?.hpInvestmentSource, initialData?.hpInvestmentSum].some(Boolean)
  )
  const [defaultBusinessUnit, setDefaultBusinessUnit] = useState('')
  const [defaultFocusArea, setDefaultFocusArea] = useState('')
  const [isGoalWarning, setIsGoalWarning] = useState(false)
  const [isGoalError, setIsGoalError] = useState(false)
  const [isGoalBelowMinimum, setIsGoalBelowMinimum] = useState(false)
  const [planValue, setPlanValue] = useState(0)
  const [descriptionPlaceholder] = useState('')

  /** -------------------- Selectors ----------------------- */

  const translationMode = useSelector(selectTranslationMode)
  const rtm = useSelector(selectRtm)

  /** -------------------- Hooks ----------------------- */

  const dispatch = useAppDispatch()
  const t = useSafetyTranslation()
  const [{ formData, isValid }] = useGetFormData(initiativeFormKey, initialData)
  const descriptionValueRef = useRef(formData?.description)
  descriptionValueRef.current = formData?.description
  const { incrementalInitialValue, isIncrementalRequired, incrementalFieldNameByValueType } =
    useIncremental<IKeyInitiativeForm>({ initialData, formData })
  const {
    checkDescriptionQuality,
    handleDescriptionBlur,
    isDescriptionQualityBlocking: isDescriptionQualitySaveBlocked,
    isDescriptionQualityChecking,
  } = useDescriptionQuality({
    formKey: initiativeFormKey,
    name: formData?.name,
    description: formData?.description,
    quality: formData?.descriptionQuality,
  })
  const businessUnits = useBusinessUnits({ programType, fYear })
  const isPracticeDevelopment = useMemo(() => {
    return getIsPracticeDevelopment(
      formData?.keyObjective,
      keyObjectives,
      formData?.isPracticeDevelopment
    )
  }, [keyObjectives, formData?.keyObjective, formData?.isPracticeDevelopment])
  useResetProgressOnPracticeDevelopmentExit({ initiativeFormKey, isPracticeDevelopment })

  /** -------------------- Variables ----------------------- */

  const businessUnitsExtended = useMemo(() => {
    let extendedBusinessUnits: IJBPActualsAndTargetsCategory[] = businessUnits
    if (programType === ProgramTypes.PC || programType === ProgramTypes.PersonalSystems) {
      extendedBusinessUnits = [
        ...EXTENDED_BUSINESS_UNITS_PS.map((el) => ({ ...el, ProgramType: programType })),
        ...businessUnits,
        ...EXTENDED_BUSINESS_UNITS_BLANK.map((el) => ({ ...el, ProgramType: programType })),
      ]
    } else if (programType === ProgramTypes.CorePrint || programType === ProgramTypes.Print) {
      extendedBusinessUnits = [
        ...EXTENDED_BUSINESS_UNITS_PRINT.map((el) => ({ ...el, ProgramType: programType })),
        ...businessUnits,
        ...EXTENDED_BUSINESS_UNITS_BLANK.map((el) => ({ ...el, ProgramType: programType })),
      ]
    }

    return extendedBusinessUnits
  }, [businessUnits, programType])

  const shouldShowAddToBridges = useMemo(() => {
    return fYear < 2024 ? isCommercial : true
  }, [fYear, isCommercial])

  const keyObjectivesSettingsList = keyObjectives

  const selectedKeyObjectiveFromArray = useMemo(() => {
    return keyObjectives.filter((item) => item.key === formData.keyObjective)
  }, [keyObjectives, formData.keyObjective])

  const practiceDevelopmentType = useMemo(() => {
    const item = selectedKeyObjectiveFromArray[0]

    return item?.key?.toLowerCase().replace(/\s+/g, '') ?? ''
  }, [selectedKeyObjectiveFromArray])

  const isAutoCreatedKeyInitiative = useMemo(
    () => formData?.initType === KeyInitiativeInitTypes.ImportedInitiative,
    [formData?.initType]
  )

  const isTranslationMode = useMemo(() => translationMode === 'edit', [translationMode])

  const focusAreaValues = useFocusAreaValues({
    keyObjectives: keyObjectivesSettingsList,
    keyObjective: formData?.keyObjective,
  })

  const isLargeFormat = useMemo(() => {
    return programType === ProgramTypes.LargeFormat
  }, [programType])

  const goalFieldName = useMemo(() => {
    return `goal${formData?.valueType}`
  }, [formData.valueType])

  const goalFieldNameWithCurrency = useMemo(() => {
    if (formData?.currency === 'USD') {
      return `${goalFieldName}Usd`
    } else {
      return `${goalFieldName}LocalCurrency`
    }
  }, [goalFieldName, formData])

  const goalInitialValue = useMemo<Nullable<number>>(() => {
    return initialData?.[goalFieldNameWithCurrency]
  }, [initialData, goalFieldNameWithCurrency])

  const isGoalRequired = useMemo(() => {
    if (formData?.initType !== null) {
      return false
    }

    return shouldShowAddToBridges && formData?.shouldAddToBridges
  }, [shouldShowAddToBridges, formData])

  const isApplyDisabled = useMemo(() => {
    return (
      !isValid ||
      isLoading ||
      isDescriptionQualityChecking ||
      isDescriptionQualitySaveBlocked ||
      (isGoalError && !formData?.justification)
    )
  }, [
    formData?.justification,
    isDescriptionQualityChecking,
    isDescriptionQualitySaveBlocked,
    isGoalError,
    isLoading,
    isValid,
  ])

  const goalWarning = useMemo(() => {
    if (!planValue) {
      return tr.keyInitiativeEditor.goalFieldGroup.emptyPlan
    }

    if (isGoalBelowMinimum) {
      return tr.keyInitiativeEditor.goalFieldGroup.lowWarning
    }

    const goalWarningKey = isGoalError
      ? tr.keyInitiativeEditor.goalFieldGroup.error
      : tr.keyInitiativeEditor.goalFieldGroup.warning

    return goalWarningKey
  }, [isGoalBelowMinimum, isGoalError, planValue])

  const goalWarningReplaceParams: TReplaceOptions[] = useMemo(() => {
    const formattedValue = !planValue ? '' : formatMoneyInteger(planValue, 0, 1)

    return [{ key: '{planValue}', value: formattedValue }]
  }, [planValue])

  const progressItems = useMemo(
    () =>
      isPracticeDevelopment
        ? getPracticeDevelopmentProgressValues(formData.currentProgress).progressItems
        : [],
    [formData.currentProgress, isPracticeDevelopment]
  )

  const selectedItems = useMemo(
    () => PROGRESS_VIEW_ITEMS.filter((item) => progressItems.includes(item.key)),
    [progressItems]
  )

  const unselectedItems = useMemo(
    () => PROGRESS_VIEW_ITEMS.filter((item) => !progressItems.includes(item.key)),
    [progressItems]
  )

  const descriptionRows = useMemo(
    () => getDescriptionRows(formData.description || '', 85),
    [formData.description]
  )

  /** -------------------- Methods ----------------------- */

  const handleValidate = useCallback(async () => {
    const formValidation = FormValidationBuilder.build(initiativeFormKey)
    const errors = await Promise.all(
      [
        formValidation.call('status', formData?.status),
        formValidation.call('name', formData?.name),
        keyObjectivesSettingsList.length &&
          formValidation.call('keyObjective', formData?.keyObjective),
        formValidation.call('period', formData?.period?.join(',')),
        formValidation.call('description', formData?.description),
        isInvestmentNeeds && formValidation.call('hpInvestmentSum', formData?.hpInvestmentSum),
        isInvestmentNeeds &&
          formValidation.call('hpInvestmentSource', formData?.hpInvestmentSource),

        isGoalRequired && formValidation.call(goalFieldName, formData[goalFieldName]),
        isIncrementalRequired &&
          formValidation.call(
            incrementalFieldNameByValueType,
            formData[incrementalFieldNameByValueType]
          ),
      ].filter((it) => it)
    )

    return errors.filter((it): it is TFormValidationResult => it !== undefined)
  }, [
    formData,
    isInvestmentNeeds,
    keyObjectivesSettingsList,
    goalFieldName,
    isGoalRequired,
    isIncrementalRequired,
    incrementalFieldNameByValueType,
    initiativeFormKey,
  ])

  const handleValidateRef = useRef(handleValidate)
  handleValidateRef.current = handleValidate

  const handleToggleItem = useCallback(
    (key: string) => {
      if (!isPracticeDevelopment) {
        return
      }

      const next = progressItems.includes(key)
        ? progressItems.filter((k) => k !== key)
        : [...progressItems, key]
      const progressValues = getPracticeDevelopmentProgressValues(next.join(','))

      dispatch(
        updateFormDataField({
          field: 'currentProgress',
          value: progressValues.currentProgress,
          formKey: initiativeFormKey,
        })
      )
      dispatch(
        updateFormDataField({
          field: 'followUp',
          value: progressValues.followUp,
          formKey: initiativeFormKey,
        })
      )
    },
    [progressItems, dispatch, initiativeFormKey, isPracticeDevelopment]
  )

  const handleApply = useCallback(async () => {
    const errors = await handleValidate()
    if (errors.length > 0) {
      return
    }

    const descriptionQuality = await checkDescriptionQuality({ force: true })
    if (isDescriptionQualityBlocking(descriptionQuality)) {
      return
    }

    setIsLoading(true)
    await onApply(formData, isInvestmentNeeds)
    if (pendingKeyInitiative) {
      dispatch(reviewKeyInitiative())
    }
    setIsLoading(false)
  }, [
    onApply,
    formData,
    isInvestmentNeeds,
    handleValidate,
    checkDescriptionQuality,
    pendingKeyInitiative,
    dispatch,
  ])

  /** -------------------- Effects ----------------------- */

  useEffect(() => {
    if (IS_VALIDATE_ON_OPENING) {
      handleValidateRef.current()
    }
  }, [])

  useEffect(() => {
    return () => {
      dispatch(resetAllModifiedDataByKey(initiativeFormKey))
    }
  }, [dispatch, initiativeFormKey])

  useEffect(() => {
    if (!initialData?.status) {
      dispatch(
        updateFormDataField({
          field: 'status',
          value: InitiativeStatus.New,
          formKey: initiativeFormKey,
        })
      )
    }
  }, [initialData?.status, dispatch, initiativeFormKey])

  useEffect(() => {
    selectedKeyObjectiveFromArray.map((item) => {
      setDefaultBusinessUnit(item.defaultBusinessUnit || '')
      setDefaultFocusArea(item.defaulFocusArea || '')
    })
  }, [selectedKeyObjectiveFromArray, defaultBusinessUnit, defaultFocusArea])

  useEffect(() => {
    if (defaultBusinessUnit) {
      dispatch(
        updateFormDataField({
          field: 'businessUnit',
          value: defaultBusinessUnit,
          formKey: initiativeFormKey,
        })
      )
    }
  }, [dispatch, defaultBusinessUnit, initiativeFormKey])

  useEffect(() => {
    if (defaultFocusArea) {
      dispatch(
        updateFormDataField({
          field: 'focusArea',
          value: defaultFocusArea,
          formKey: initiativeFormKey,
        })
      )
    }
  }, [dispatch, defaultFocusArea, initiativeFormKey])

  useEffect(() => {
    if (finSobData) {
      const { isWarning, isError, isGoalBelowMinimum, planValue } = finSobValidation(
        formData,
        finSobData,
        goalFieldName
      )
      setIsGoalWarning(isWarning)
      setIsGoalError(isError)
      setIsGoalBelowMinimum(isGoalBelowMinimum)
      setPlanValue(planValue)
    }
  }, [finSobData, formData, goalFieldName, incrementalFieldNameByValueType])

  useEffect(() => {
    if (isPracticeDevelopment && !initialData?.name) {
      dispatch(
        updateFormDataField({
          field: 'name',
          value: PRACTICE_DEVELOPMENT,
          formKey: initiativeFormKey,
        })
      )
    }
  }, [isPracticeDevelopment, dispatch, initialData?.name, initiativeFormKey])

  useEffect(() => {
    if (isPracticeDevelopment && !initialData?.description) {
      const newDescription = t(
        `${tr.keyInitiativeEditor.practiceDevelopment.description}-${practiceDevelopmentType}`
      )
      dispatch(
        updateFormDataField({
          field: 'description',
          value: newDescription,
          formKey: initiativeFormKey,
        })
      )
    }
  }, [
    isPracticeDevelopment,
    practiceDevelopmentType,
    dispatch,
    t,
    initialData?.description,
    initiativeFormKey,
  ])

  /** -------------------- Render ----------------------- */

  return (
    <div className={styles.root}>
      <LoaderOverlay show={isLoading} />
      <RenderWhen condition={initialData?.isFromGlobalPartner}>
        <FormSwitch
          margin={'md'}
          formKey={initiativeFormKey}
          field={'isNotApplicable'}
          defaultValue={initialData?.isNotApplicable || false}
          label={
            formData?.isNotApplicable
              ? tr.keyInitiativeEditor.isApplicable
              : tr.keyInitiativeEditor.isNotApplicable
          }
        />
      </RenderWhen>
      <RenderWhen condition={!formData.isNotApplicable}>
        <Grid noRootMargin direction="row">
          <Item xs={9} className={styles.labelItem}>
            <Translation
              text={
                tr.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.strategicInitiativeLabel
              }
              span
            />
          </Item>
          <Item xs={3} className={styles.labelItem}>
            <Translation
              text={tr.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.periodLabel}
              span
            />
          </Item>
          <Item xs={9}>
            <KeyObjectives
              formKey={initiativeFormKey}
              isDisabled={
                isAutoCreatedKeyInitiative ||
                isAmplifyImpactInfoSection ||
                initialData?.isFromGlobalPartner
              }
              className={styles.formField}
              initialValue={
                isAmplifyImpactInfoSection ? 'Amplify Impact' : initialData?.keyObjective
              }
              keyObjectivesSettingsList={keyObjectivesSettingsList}
              programType={programType}
              keyObjectivesFilter={keyObjectivesFilter}
              caption="Breadcrumb"
              label={tr.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.development}
            />
          </Item>
          <Item xs={3} className={styles.periodSelector}>
            <PeriodSelector
              formKey={initiativeFormKey}
              isRequired
              isDisabled={isAutoCreatedKeyInitiative || initialData?.isFromGlobalPartner}
              className={styles.formField}
              initialValue={initialData?.period}
            />
          </Item>
        </Grid>
        <Grid noRootMargin direction="row">
          <Item xs={6}>
            <Name
              isDisabled={initialData?.isFromGlobalPartner || isPracticeDevelopment}
              formKey={initiativeFormKey}
              initialValue={initialData?.name || ''}
              label={tr.keyInitiativeEditor.name}
            />
          </Item>
          <Item xs={6}>
            <Status
              formKey={initiativeFormKey}
              isDisabled={isAutoCreatedKeyInitiative}
              initialValue={initialData?.status}
            />
          </Item>
        </Grid>
        <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
          <Item xs={12}>
            <KeyObjectivesTree
              keyObjectivesSettingsList={keyObjectivesSettingsList}
              formKey={initiativeFormKey}
              initialValue={initialData?.keyObjectiveTags || []}
              programType={programType}
              rtm={rtm}
            />
          </Item>
          {initialData?.isFromGlobalPartner && (
            <Item xs={6}>
              <ActivityType
                isDisabled={initialData?.isFromGlobalPartner}
                formKey={initiativeFormKey}
                initialValue={initialData.activityType}
              />
            </Item>
          )}
          <Item xs={initialData?.isFromGlobalPartner ? 6 : 12}>
            <FormInput
              isDisabled={isAutoCreatedKeyInitiative || initialData?.isFromGlobalPartner}
              formKey={initiativeFormKey}
              field="owner"
              defaultValue={initialData?.owner || ''}
              type="text"
              label={tr.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.owner}
            />
          </Item>
        </Grid>
        {!isAutoCreatedKeyInitiative && !isPracticeDevelopment && (
          <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
            <Item xs={12} className={styles.labelItem}>
              <Translation text={tr.keyInitiativeEditor.checkboxesFieldGroup.groupHint} />
            </Item>
            {!isLargeFormat && isDataInsightPresent && (
              <Item xs={6}>
                <FormCheckBox
                  isDisabled={
                    isKeyObjectiveRelated(keyObjectivesSettingsList, initialData) ||
                    isDataInsightTab ||
                    initialData?.isFromGlobalPartner
                  }
                  formKey={initiativeFormKey}
                  field="isDataInsightRelated"
                  defaultValue={initialData?.isDataInsightRelated || isDataInsightTab}
                  label={tr.keyInitiativeEditor.checkboxesFieldGroup.dataInsightRelated}
                />
              </Item>
            )}

            {shouldShowAddToBridges && (
              <Item xs={6}>
                <FormCheckBox
                  isDisabled={initialData?.isFromGlobalPartner}
                  formKey={initiativeFormKey}
                  field="shouldAddToBridges"
                  defaultValue={initialData?.shouldAddToBridges || false}
                  label={tr.keyInitiativeEditor.checkboxesFieldGroup.shouldAddToBridges}
                />
              </Item>
            )}
          </Grid>
        )}
        {!isAutoCreatedKeyInitiative && (
          <>
            <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
              <Item xs={12} className={cn(styles.labelItem, styles.noMargin)}>
                <Translation text={tr.keyInitiativeEditor.goalFieldGroup.groupHint} />
              </Item>

              <RenderWhen condition={!initialData?.isFromGlobalPartner}>
                <Item xs={3}>
                  <Goal
                    formKey={initiativeFormKey}
                    isRequired={isGoalRequired}
                    initialValue={goalInitialValue}
                    currency={formData?.currency}
                    valueType={formData?.valueType}
                    className={styles.formField}
                    goalFieldName={goalFieldName}
                  />
                </Item>
              </RenderWhen>
              <Item xs={3}>
                <Incremental
                  formKey={initiativeFormKey}
                  isRequired={isIncrementalRequired}
                  initialValue={incrementalInitialValue}
                  currency={formData?.currency}
                  valueType={formData?.valueType}
                  className={styles.formField}
                  shouldAddToBridges={formData?.shouldAddToBridges}
                  goal={formData?.[goalFieldName]}
                  incrementalFieldName={incrementalFieldNameByValueType}
                  isFromGlobalPartner={initialData?.isFromGlobalPartner}
                  goalFieldName={goalFieldName}
                />
              </Item>
              <Item xs={6}>
                <ValueTypeAndCurrency
                  formKey={initiativeFormKey}
                  initialCurrency={initialData?.currency}
                  initialValueType={initialData?.valueType}
                />
              </Item>
            </Grid>
            {isGoalWarning && (
              <Grid noRootMargin direction="row">
                <Item
                  xs={12}
                  className={cn(styles.goalWarning, { [styles.goalJustification]: isGoalError })}
                >
                  <Translation text={goalWarning} replaceParams={goalWarningReplaceParams} />
                </Item>
                {isGoalError && (
                  <Item xs={12}>
                    <FormInput
                      formKey={initiativeFormKey}
                      field="justification"
                      defaultValue={initialData?.justification || ''}
                      type="text"
                      label={tr.keyInitiativeEditor.goalFieldGroup.justification}
                    />
                  </Item>
                )}
              </Grid>
            )}
          </>
        )}
        <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
          <Item xs={12} className={styles.labelItem}>
            <Translation text={tr.keyInitiativeEditor.businessUnitAndFocusFieldGroup.groupHint} />
          </Item>
          <Item xs={6}>
            <BusinessUnit
              isDisabled={initialData?.isFromGlobalPartner}
              formKey={initiativeFormKey}
              initialValue={initialData?.businessUnit}
              businessUnits={businessUnitsExtended}
              className={styles.formField}
              label={tr.keyInitiativeEditor.businessUnitAndFocusFieldGroup.businessUnit}
            />
          </Item>
          <Item xs={6}>
            <FocusArea
              formKey={initiativeFormKey}
              isDisabled={isAutoCreatedKeyInitiative || initialData?.isFromGlobalPartner}
              initialValue={initialData?.focusArea}
              focusAreaValues={focusAreaValues}
              className={styles.formField}
              businessUnit={formData?.businessUnit}
              fYear={fYear}
              programType={programType}
              extendedItems={EXTENDED_FOCUS_AREA}
            />
          </Item>
          <Item xs={12} className={styles.labelItem}>
            <FormFieldValidationLabel
              text={tr.keyInitiativeEditor.businessUnitAndFocusFieldGroup.description}
              formKey={initiativeFormKey}
              fields={['description']}
            />
          </Item>
          {formData?.descriptionQuality && (
            <Item xs={12}>
              <DescriptionQuality quality={formData.descriptionQuality} />
            </Item>
          )}
          <Item xs={12}>
            <FormTextarea
              isDisabled={isAutoCreatedKeyInitiative || initialData?.isFromGlobalPartner}
              isRequired={!isAutoCreatedKeyInitiative}
              formKey={initiativeFormKey}
              field="description"
              defaultValue={initialData?.description || ''}
              onValidate={ValidationHelper.checkString}
              validationType={ValidationType.ONCHANGE}
              onChange={(value) => {
                descriptionValueRef.current = value
              }}
              onBlur={() => handleDescriptionBlur(descriptionValueRef.current)}
              rows={descriptionRows}
              placeholder={descriptionPlaceholder}
            />
            {isTranslationMode && isPracticeDevelopment && (
              <Translation
                text={`${tr.keyInitiativeEditor.practiceDevelopment.description}-${practiceDevelopmentType}`}
              />
            )}
          </Item>
          {isPracticeDevelopment && (
            <>
              <Item xs={12} className={styles.labelItem}>
                <Translation text={tr.keyInitiativeEditor.progressView.groupHint} />
              </Item>
              <Item xs={12}>
                <ProgressDropdown progressItems={progressItems} onToggleItem={handleToggleItem} />
              </Item>
              <Item xs={6}>
                <Translation
                  text={tr.keyInitiativeEditor.businessUnitAndFocusFieldGroup.currentProgress}
                />
                <ul className={styles.progressList}>
                  {selectedItems.map((item) => (
                    <li key={item.key}>
                      <Translation text={`${item.key}${PROGRESS_VIEW_LABEL_SUFFIX}`} span />
                    </li>
                  ))}
                </ul>
              </Item>
              <Item xs={6}>
                <Translation
                  text={tr.keyInitiativeEditor.businessUnitAndFocusFieldGroup.followUp}
                />
                <ul className={styles.progressList}>
                  {unselectedItems.map((item) => (
                    <li key={item.key}>
                      <Translation text={`${item.key}${PROGRESS_VIEW_LABEL_SUFFIX}`} span />
                    </li>
                  ))}
                </ul>
              </Item>
            </>
          )}
          {!isPracticeDevelopment && (
            <>
              <Item xs={6} className={styles.labelItem}>
                <div>
                  <Translation text={tr.keyInitiativeEditor.progressView.currentProgressLabel} />
                </div>
              </Item>
              <Item xs={6} className={styles.labelItem}>
                <div>
                  <Translation text={tr.keyInitiativeEditor.progressView.followUpLabel} />
                </div>
              </Item>
              <Item xs={6}>
                <FormTextarea
                  defaultValue={initialData?.currentProgress || ''}
                  field="currentProgress"
                  formKey={initiativeFormKey}
                  placeholder={tr.keyInitiativeEditor.progressView.currentProgressPlaceholder}
                />
              </Item>
              <Item xs={6}>
                <FormTextarea
                  defaultValue={initialData?.followUp || ''}
                  field="followUp"
                  formKey={initiativeFormKey}
                  placeholder={tr.keyInitiativeEditor.progressView.followUpPlaceholder}
                />
              </Item>
              {isTranslationMode && (
                <>
                  <Item xs={6}>
                    <Translation
                      text={tr.keyInitiativeEditor.progressView.currentProgressPlaceholder}
                    />
                  </Item>
                  <Item xs={6}>
                    <Translation text={tr.keyInitiativeEditor.progressView.followUpPlaceholder} />
                  </Item>
                </>
              )}
            </>
          )}
        </Grid>
        {isAutoCreatedKeyInitiative && (
          <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
            <Item xs={12} className={styles.labelItem}>
              <Translation
                text={tr.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup.groupHint}
              />
            </Item>
            <Item xs={12}>
              {isTranslationMode && (
                <Translation
                  text={
                    tr.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup.goalDescription
                  }
                />
              )}
              {!isTranslationMode && (
                <FormTextarea
                  isDisabled={isAutoCreatedKeyInitiative || initialData?.isFromGlobalPartner}
                  formKey={initiativeFormKey}
                  field="goalDescription"
                  defaultValue={initialData?.goalDescription || ''}
                  label={
                    tr.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup.goalDescription
                  }
                />
              )}
            </Item>
            <Item xs={12}>
              <FormCheckBox
                isDisabled={isAutoCreatedKeyInitiative || initialData?.isFromGlobalPartner}
                formKey={initiativeFormKey}
                field="isAchieved"
                defaultValue={initialData?.isAchieved || false}
                label={tr.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup.isAchieved}
              />
            </Item>
            <Item xs={12}>
              {isTranslationMode && (
                <Translation
                  text={
                    tr.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup.proofOfExecution
                  }
                />
              )}
              {!isTranslationMode && (
                <FormTextarea
                  isDisabled={isAutoCreatedKeyInitiative || initialData?.isFromGlobalPartner}
                  formKey={initiativeFormKey}
                  field="proofOfExecution"
                  defaultValue={initialData?.proofOfExecution || ''}
                  label={
                    tr.keyInitiativeEditor.capabilitiesPillarInitiativeFieldGroup.proofOfExecution
                  }
                  className={styles.formField}
                />
              )}
            </Item>
          </Grid>
        )}
        {!isPracticeDevelopment && (
          <>
            <Grid noRootMargin direction="row" className={styles.fieldsetContainer}>
              <Item xs={12} className={styles.investmentNeedsWrapper}>
                <Checkbox
                  disabled={initialData?.isFromGlobalPartner}
                  checked={isInvestmentNeeds}
                  label={t(tr.keyInitiativeEditor.investmentFieldGroup.groupHint)}
                  onChange={setInvestmentNeeds}
                />
              </Item>
            </Grid>
            {isInvestmentNeeds && (
              <Grid noRootMargin direction="row">
                <Item xs={6}>
                  <InvestmentSum
                    isDisabled={initialData?.isFromGlobalPartner}
                    formKey={initiativeFormKey}
                    initialValue={initialData?.hpInvestmentSum}
                    className={styles.formField}
                    label={tr.keyInitiativeEditor.investmentFieldGroup.investmentSum}
                  />
                </Item>
                <Item xs={6}>
                  <InvestmentSource
                    isDisabled={initialData?.isFromGlobalPartner}
                    formKey={initiativeFormKey}
                    initialValue={initialData?.hpInvestmentSource}
                    className={styles.formField}
                    label={tr.keyInitiativeEditor.investmentFieldGroup.investmentSource}
                  />
                </Item>
              </Grid>
            )}
          </>
        )}
      </RenderWhen>

      <Grid direction="row" className={styles.buttonsContainer}>
        <Item xs={6} className={styles.buttonsContainerLeft}>
          {!saveAsNew && !!setKeyInitiativesFormat && (
            <WidgetView value={keyInitiativesFormat} onOptionClick={setKeyInitiativesFormat} />
          )}
        </Item>
        <Item xs={6} className={styles.buttonsContainerRight}>
          <CancelButton onClick={onCancel} className={styles.cancelButton} color="grey" />
          <ApplyButton
            text={saveAsNew ? tr.keyInitiativeEditor.copyAsNewButton : undefined}
            className={styles.applyButton}
            disabled={isApplyDisabled}
            onClick={handleApply}
          />
        </Item>
      </Grid>
    </div>
  )
}
